import { statusCategories } from '@atlassian/jira-common-constants/src/index.tsx';
import { MAP_FROM_SERVER_COLOR } from '@atlassian/jira-issue-epic-color/src/common/constants.tsx';
import type { ServerColor } from '@atlassian/jira-issue-epic-color-types/src/types.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { ParentFieldOption } from '../../common/types.tsx';
import type {
	AggJiraParentConnection,
	AggJiraParentConnectionNode,
} from '../../ui/parent/types.tsx';

const transformParentNodeOld = (edgeNode: AggJiraParentConnectionNode): ParentFieldOption => {
	const fieldsEdges = edgeNode?.fieldsById?.edges || [];
	const summaryField = fieldsEdges.find((field) => field?.node?.fieldId === 'summary');
	const issueTypeField = fieldsEdges.find((field) => field?.node?.fieldId === 'issuetype');
	const statusField = fieldsEdges.find((field) => field?.node?.fieldId === 'status');
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	const colorKey = edgeNode?.issueColorField?.color?.colorKey as ServerColor;

	const checkParentIssueIsDone = (statusCategoryId: string): boolean => {
		const doneStatusCategoryId =
			statusCategories.StatusCategoryIds[statusCategories.StatusCategoryTypes.DONE];
		return doneStatusCategoryId && String(doneStatusCategoryId) === statusCategoryId;
	};

	const isDone = checkParentIssueIsDone(
		statusField?.node?.status?.statusCategory?.statusCategoryId || '',
	);

	return {
		id: edgeNode?.id || '',
		key: edgeNode?.key || '',
		// @ts-expect-error Type 'string | undefined' is not assignable to type 'string'.
		issueId: edgeNode?.issueId || undefined,
		// @ts-expect-error Type 'string | undefined' is not assignable to type 'string'.
		webUrl: edgeNode?.webUrl || undefined,
		fields: {
			issuetype: {
				id: issueTypeField?.node?.issueType?.issueTypeId || '',
				name: issueTypeField?.node?.issueType?.name || '',
				iconUrl: issueTypeField?.node?.issueType?.avatar?.xsmall || '',
			},
			summary: summaryField?.node?.text || '',
		},
		color: colorKey in MAP_FROM_SERVER_COLOR ? MAP_FROM_SERVER_COLOR[colorKey] : undefined,
		value: edgeNode?.id || '',
		label: `${edgeNode?.key || ''} ${summaryField?.node?.text || ''}`,
		isDone,
		aggValue: edgeNode,
	};
};

export const transformParentNode = (edgeNode: AggJiraParentConnectionNode): ParentFieldOption => {
	if (!fg('dfo_remove_fields_by_id')) {
		return transformParentNodeOld(edgeNode);
	}

	const summaryField = edgeNode?.summaryField;
	const issueTypeField = edgeNode?.issueTypeField;
	const statusField = edgeNode?.statusField;
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	const colorKey = edgeNode?.issueColorField?.color?.colorKey as ServerColor;

	const checkParentIssueIsDone = (statusCategoryId: string): boolean => {
		const doneStatusCategoryId =
			statusCategories.StatusCategoryIds[statusCategories.StatusCategoryTypes.DONE];
		return doneStatusCategoryId && String(doneStatusCategoryId) === statusCategoryId;
	};

	const isDone = checkParentIssueIsDone(
		statusField?.status?.statusCategory?.statusCategoryId || '',
	);

	return {
		id: edgeNode?.id || '',
		key: edgeNode?.key || '',
		// @ts-expect-error Type 'string | undefined' is not assignable to type 'string'.
		issueId: edgeNode?.issueId || undefined,
		// @ts-expect-error Type 'string | undefined' is not assignable to type 'string'.
		webUrl: edgeNode?.webUrl || undefined,
		fields: {
			issuetype: {
				id: issueTypeField?.issueType?.issueTypeId || '',
				name: issueTypeField?.issueType?.name || '',
				iconUrl: issueTypeField?.issueType?.avatar?.xsmall || '',
			},
			summary: summaryField?.text || '',
		},
		color: colorKey in MAP_FROM_SERVER_COLOR ? MAP_FROM_SERVER_COLOR[colorKey] : undefined,
		value: edgeNode?.id || '',
		label: `${edgeNode?.key || ''} ${summaryField?.text || ''}`,
		isDone,
		aggValue: edgeNode,
	};
};

export const transformToSuggestions = (
	fieldOptionsData: AggJiraParentConnection,
): ParentFieldOption[] =>
	(fieldOptionsData?.edges || [])
		?.filter((edge) => edge?.node)
		.map((edge) => transformParentNode(edge?.node));
